module.exports = __webpack_public_path__ + "static/1-ac1c1f35c0f28bc40823b6ba1d1671bc.jpg";